import type { MoveBpaCsvRow } from "./parseMoveBpaCsv.js";

const MISMATCH_PATTERN = /\bexpected\b.*\bmatched\b/i;

export function firmLabel({ firmRef, firmName }: MoveBpaCsvRow): string {
  return firmName ? `${firmName} (${firmRef})` : firmRef;
}

export function groupLabel({ sourcePracticeAreaIds }: MoveBpaCsvRow): string {
  return sourcePracticeAreaIds.join("; ");
}

export function targetLabel({ target }: MoveBpaCsvRow): string {
  const table =
    target.tableName === target.practiceAreaName
      ? `table ${target.tableId}`
      : `table ${target.tableId} "${target.tableName}"`;
  return `${target.practiceAreaName} (practice area ${target.practiceAreaId}, ${table})`;
}

export function isMismatchWarning(warning: string): boolean {
  return MISMATCH_PATTERN.test(warning);
}
